/**
 * AdminGuard — wraps admin routes (§27.3).
 *
 * Layered on top of RequireAuth: auth is checked first so unauthenticated
 * users land on /login, then we check Cognito group membership. Non-admins
 * get redirected to the project list home rather than 404'd — the admin
 * panel is intentionally unadvertised, so a stray link from a bookmark
 * should land cleanly.
 */
import { Navigate } from "react-router-dom";
import { isAdmin } from "../services/auth.js";

export default function AdminGuard({ children }) {
  if (!isAdmin()) {
    return <Navigate to="/" replace />;
  }
  return children;
}
